import React from 'react'
import EcoClear from '../svg/ecoClearLogo'

import {
  EndBannerSection,
  EndBannerContainer,
  Hook,
  LearnMore
} from './styles'

const EndBanner = ({ data }) => {
  return (
    <EndBannerSection bg={data.backgroundImage.fluid.src}>
    {/* <EndBannerSection bg={data.backgroundImage.fluid.srcWebp}> */}
      <EndBannerContainer>
        <EcoClear size="450" primary="#fff" secondary="#fff"/>
        <Hook>{data.hook}</Hook>
        <LearnMore to={`/${data.mainActionUrl}`}>{data.mainActionText}</LearnMore>
      </EndBannerContainer>
    </EndBannerSection>
  )
}

export default EndBanner
